export default __webpack_public_path__ + "static/media/round.a3c5c15b.svg";